import { combineReducers } from 'redux'
import ArrayUtil from '@leverege/array-util'

import { BreadcrumbActions } from '~/actions/'

const initialState = []

function breadcrumbs( state = initialState, action ) {

  switch ( action.type ) {

    case BreadcrumbActions.BREADCRUMBS_SET:
      return action.breadcrumbs;
    
    default:
      return state
  }
}

module.exports = breadcrumbs;
